module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "red darken-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.user.fullname) + " " + _vm._s(_vm.$v.dirty ? '*' : ''))])], 1), _vm._v(" "), _c('v-form', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Identifiant",
      "disabled": _vm.userId > 0,
      "error-messages": _vm.usernameErrors,
      "blur": "$v.user.username.$touch(); $v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.username.$touch();
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "name": "email",
      "error-messages": _vm.emailErrors,
      "blur": "$v.user.email.$touch(); $v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.email.$touch();
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Rôles",
      "loading": _vm.loading,
      "disabled": _vm.loggedInUserRoles.hasOwnProperty('salutance-user') || _vm.loggedInUserRoles.hasOwnProperty('diamond-user'),
      "multiple": "",
      "chips": "",
      "cache-items": "",
      "items": _vm.roles,
      "item-text": "params.member_name",
      "item-value": "id",
      "search-input": _vm.search,
      "blur": "$v.user.roles.$touch(); $v.user.$touch()",
      "error-messages": _vm.rolesErrors
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        _vm.$v.user.roles.$touch();
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.roles),
      callback: function($$v) {
        _vm.$set(_vm.user, "roles", $$v)
      },
      expression: "user.roles"
    }
  })], 1), _vm._v(" "), (_vm.userExtras.fullname && !_vm.userExtras.firstlastname) ? _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nom complet",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.fullname),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "fullname", $$v)
      },
      expression: "user.extra.fullname"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.firstlastname) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Prénom",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "first_name", $$v)
      },
      expression: "user.first_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.firstlastname) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nom",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "last_name", $$v)
      },
      expression: "user.last_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Tag",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.tag),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "tag", $$v)
      },
      expression: "user.extra.tag"
    }
  })], 1), _vm._v(" "), (_vm.userExtras.coaches) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Tuteurs",
      "loading": _vm.loading,
      "disabled": _vm.loggedInUserRoles.hasOwnProperty('salutance-user'),
      "multiple": "",
      "chips": "",
      "cache-items": "",
      "items": _vm.users,
      "item-text": "fullname",
      "item-value": "id",
      "search-input": _vm.search,
      "blur": "$v.user.$touch(); $v.user.$touch()"
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "input": function($event) {
        _vm.$v.user.$touch();
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.coaches),
      callback: function($$v) {
        _vm.$set(_vm.user, "coaches", $$v)
      },
      expression: "user.coaches"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.nutrieduc) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Sexe",
      "items": _vm.genders,
      "item-text": "name",
      "item-value": "code",
      "blur": "$v.user.$touch()",
      "error-messages": _vm.genderErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.gender),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "gender", $$v)
      },
      expression: "user.extra.gender"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.nutrieduc) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "error-messages": _vm.birthdateErrors,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "min-width": "290px"
    },
    model: {
      value: (_vm.birthdate_menu),
      callback: function($$v) {
        _vm.birthdate_menu = $$v
      },
      expression: "birthdate_menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Date de naissance",
      "value": _vm.user.extra.birthdate ? _vm.moment(_vm.user.extra.birthdate).format('LL') : '',
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    ref: "picker",
    attrs: {
      "max": new Date().toISOString().substr(0, 10),
      "locale": "fr-FR",
      "first-day-of-week": 1,
      "scrollable": "",
      "blur": "$v.user.$touch()"
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.birthdate_temp),
      callback: function($$v) {
        _vm.birthdate_temp = $$v
      },
      expression: "birthdate_temp"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.birthdate_menu = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.user.extra.birthdate = _vm.birthdate_temp;
        _vm.birthdate_menu = false
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.nutrieduc) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Fumeur",
      "items": _vm.smokers,
      "item-text": "name",
      "item-value": "code",
      "blur": "$v.user.$touch()",
      "error-messages": _vm.smokerErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.smoker),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "smoker", $$v)
      },
      expression: "user.extra.smoker"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.heightweightbmi) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Taille (cm)",
      "blur": "$v.user.$touch()",
      "error-messages": _vm.heightErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.height),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "height", $$v)
      },
      expression: "user.extra.height"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.heightweightbmi) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Poids (kg)",
      "blur": "$v.user.$touch()",
      "error-messages": _vm.weightErrors
    },
    on: {
      "input": function($event) {
        _vm.$v.user.$touch()
      }
    },
    model: {
      value: (_vm.user.extra.weight),
      callback: function($$v) {
        _vm.$set(_vm.user.extra, "weight", $$v)
      },
      expression: "user.extra.weight"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.heightweightbmi) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "IMC",
      "value": _vm.imc,
      "disabled": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userExtras.fitbit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "href": _vm.fitbitAuthorizationURL,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.user.extra.fitbit_user_id ? "Réassocier" : "Associer") + " à un compte Fitbit")])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.formValidAndDirty,
      "flat": ""
    },
    on: {
      "click": _vm.saveOrUpdate
    }
  }, [_vm._v(_vm._s(_vm.saveMessage))]), _vm._v(" "), (!_vm.creation) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.sendResetPasswordMail
    }
  }, [_vm._v("Réinitialiser le mot de passe")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d0fe68a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/User.vue
// module id = 1189
// module chunks = 1